// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19 2V4L5 4V2H19Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 7.5L21 7.5V5.5L3 5.5V7.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 22V9L1 9V22H23ZM15 15.5001L9.75 18.5312V12.469L15 15.5001Z"}}]};

const MediaLibraryFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'media-library-filled',
    ref,
    icon: element,
  },
));

MediaLibraryFilledIcon.displayName = 'MediaLibraryFilledIcon';

export default MediaLibraryFilledIcon;
